import store from '../store'

export function updateRoadmapsHomePageSetting(setting,value) {	
	store.dispatch({ type:'UPDATE_ROADMAPS_HOME_PAGE_SETTING',setting,value})
}
